// extracted by mini-css-extract-plugin
export default {"header":"header_header__OfCNr","content":"header_content__KlCMB","logo":"header_logo__LlTMK","menu":"header_menu__aJQQa","hamburger-wrapper":"header_hamburger-wrapper__a6jCX"};